module.exports = __webpack_public_path__ + "img/destaques.da7365a0.svg";